
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pakkereiser",
      function () {
        return require("private-next-pages/pakkereiser.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pakkereiser"])
      });
    }
  